
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons'

export default {
name: 'app',
components: {
XHeader,
Tabbar,
TabbarItem,
'v-icon': Icon
}
}



// WEBPACK FOOTER //
// ./src/App.vue